export const iconFontAwesomeSocialHashtag = (
	<i className="fa-solid fa-hashtag"></i>
);
